import React from 'react';
import { useSelector } from 'react-redux';
import { useTheme } from '@emotion/react';
import { Button, Dialog } from '@gumtree/ui-library';

import {
    DialogContainer,
    LargeDialogContainer,
    DialogButtons,
    ErrorDialogButton,
    SmallDialogContainer,
    manageAlertButtonCss,
} from './info-dialog.style';
import type { SrpState } from '../reducers';

export const InfoDialog = ({
    isDialogOpened,
    onDialogCloseClick,
}: {
    isDialogOpened: boolean;
    onDialogCloseClick: () => void;
}) => {
    const { buyerUrl, currentUrl, infoDialogContentMode } = useSelector(
        ({
            baseConfig: { sellerUrl, buyerUrl },
            socialData: { currentUrl },
            saveSearch: { infoDialogContentMode },
        }: SrpState) => ({
            sellerUrl,
            buyerUrl,
            currentUrl,
            infoDialogContentMode,
        })
    );

    const theme = useTheme();

    return (
        <DialogContainer>
            <LargeDialogContainer>
                {infoDialogContentMode === 'CONFIRMED' && (
                    <Dialog
                        isOpen={isDialogOpened}
                        onClose={onDialogCloseClick}
                        title="Your alert is set"
                        className="search-alert-dialog"
                    >
                        <span>You’ll receive an email alert when new ads match your search.</span>
                        <DialogButtons>
                            <Button
                                display="secondary"
                                label="Close"
                                onClick={onDialogCloseClick}
                            />
                            <a href="/my-account/saved-searches" css={manageAlertButtonCss(theme)}>
                                Manage alerts
                            </a>
                        </DialogButtons>
                    </Dialog>
                )}
            </LargeDialogContainer>
            {infoDialogContentMode === 'NOT_LOGGED_IN' && (
                <SmallDialogContainer>
                    <Dialog
                        isOpen={isDialogOpened}
                        onClose={onDialogCloseClick}
                        title="You need to login to set a search alert."
                        className="search-alert-dialog"
                    >
                        <a href={`${buyerUrl}/login?cb=${encodeURIComponent(currentUrl)}`}>Login</a>
                        <span>or</span>
                        <a href={`${buyerUrl}/create-account`}>Register</a>
                    </Dialog>
                </SmallDialogContainer>
            )}
            {infoDialogContentMode === 'ERROR' && (
                <SmallDialogContainer>
                    <Dialog
                        isOpen={isDialogOpened}
                        onClose={onDialogCloseClick}
                        title="Sorry, something went wrong, please try again later."
                        className="search-alert-dialog"
                    >
                        <ErrorDialogButton>
                            <Button
                                display="secondary"
                                label="Close"
                                onClick={onDialogCloseClick}
                                className="error-modal-button"
                            />
                        </ErrorDialogButton>
                    </Dialog>
                </SmallDialogContainer>
            )}
            {infoDialogContentMode === 'LIMIT_REACHED' && (
                <LargeDialogContainer>
                    <Dialog
                        isOpen={isDialogOpened}
                        onClose={onDialogCloseClick}
                        title="Something went wrong"
                        className="search-alert-dialog"
                    >
                        <span>
                            You’ve reached the maximum number of search alerts. Go to{/* */}
                            <a href="/my-account/saved-searches" className="alerts-list-href">
                                {' '}
                                manage alerts{' '}
                            </a>
                            {/* */}
                            to delete a search alert.
                        </span>

                        <DialogButtons>
                            <Button
                                display="secondary"
                                label="Close"
                                onClick={onDialogCloseClick}
                            />
                            <a href="/my-account/saved-searches" css={manageAlertButtonCss(theme)}>
                                Manage alerts
                            </a>
                        </DialogButtons>
                    </Dialog>
                </LargeDialogContainer>
            )}
        </DialogContainer>
    );
};
